











































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchVerificacion } from '../fetchVerificacion';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridReadyEvent, GridApi } from 'ag-grid-community';
import InformacionGeneral from './InformacionGeneral.vue';
import TabalSimsSelected from './TabalSimsSelected.vue';

@Component({
  components: {
    DatePicker,
    'app-confirmacion': Confirmation,
    InformacionGeneral,
    TabalSimsSelected,
  },
})
export default class EditarSolicitud extends Vue {
  @Prop({ required: true }) editedItem: any;

  ordesList: any;
  data: any = {};
  step = 'general';
  cantidadConfirmados: number = 0;

  modalGeneral: any;
  modalDetalles: any;
  mounted() {
    this.modalGeneral = this.$refs.general;
    this.modalDetalles = this.$refs.equipos;
  }
  ejecutada: boolean = false;
  buscarEquipos() {
    this.modalDetalles.cargarEquipos();
    this.ejecutada = true;
  }

  async grabarEdicion() {
    let motivo = this.modalGeneral.motivoId;
    let observacion = this.modalGeneral.formFields.observacion.value;
    let cantidadSims = this.modalGeneral.formFields.cantidadSimCards.value;
    if (this.modalDetalles.ordesList.length == 0) {
      this.$snotify.error('Por favor, confirme al menos un dispositivo', {
        timeout: 3000,
      });
      return;
    }
    let editarGeneral = await this.modalGeneral.editarSolicitud();
    if (!editarGeneral) {
      return;
    }
    let editardetalles = await this.modalDetalles.editarDetalles(
      motivo,
      observacion,
      cantidadSims
    );
    if (editardetalles) {
      this.$snotify.success('Solicitud editada con exito', {
        timeout: 3000,
      });
      this.closeModal(false);
    }
  }

  cargarSims(cantSims: number) {
    this.modalGeneral.cambiarCantSims(cantSims);
  }

  cargarConfirmados(cantidad: number) {
    this.modalGeneral.cambiarConfirmados(cantidad);
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  //abstract
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.MovimientoDispositivos;

  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;

  //Interface
  estadoSwitch: boolean = false;

  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  //@Watch('show')
  async onPropertyChanged(value: boolean) {
    this.dialog = value;
    this.dialog = value;
    // permisos
    this.setBotonNav();
  }

  setBotonNav() {
    var accion = 'Editar';
    var evaluado = false;
  }

  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }

  closeModal(val: boolean) {
    this.$validator.reset();
    document.getElementById('cardDivTV').scrollIntoView(true);
    this.$emit('modalAsociacionEmit', false);
    this.dialog = false;
    this.btnBloquear = false;
  }

  confirmCallback(val: any) {}

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }
}
